import React from "react";
import { FormGroup, Input, Label } from "reactstrap";

const DayOptionRadios = ({ name, value, disabled, onChange }) => (
    <div className="d-flex gap-3 mt-1 mb-2">
        {[
            { val: "FULL", label: "Full day" },
            { val: "FIRST_HALF", label: "First half" },
            { val: "SECOND_HALF", label: "Second half" },
        ].map(({ val, label }) => (
            <FormGroup check key={val} className="mb-0">
                <Input
                    type="radio"
                    name={name}
                    id={`${name}_${val}`}
                    checked={value === val}
                    disabled={disabled}
                    onChange={() => onChange(val)}
                />
                <Label check htmlFor={`${name}_${val}`} style={{ fontSize: 13 }}>
                    {label}
                </Label>
            </FormGroup>
        ))}
    </div>
);

export default DayOptionRadios;